import { render, staticRenderFns } from "./BookingRecalculatePrices.vue?vue&type=template&id=4a7f31a6"
import script from "./BookingRecalculatePrices.vue?vue&type=script&lang=js"
export * from "./BookingRecalculatePrices.vue?vue&type=script&lang=js"
import style0 from "./BookingRecalculatePrices.vue?vue&type=style&index=0&id=4a7f31a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports